<template>
  <div id="order-coupons">
    <div v-if="!orderSpecialPrice" class="order-coupons-body">

      <div class="order-coupons-header">
        <div class="left-content">
          <s-checkbox class="check-coupon" v-if="orderCoupons && orderCoupons.length" :value="useCoupon" @input="changeUseCouponSelect"></s-checkbox>
          <span class="coupon-title">使用优惠券</span>
          <span class="price" v-if="orderSelectedCoupon.id">（<span>-￥{{ couponReducePrice / 100 }}</span>）</span>
          <img class="query-icon" @click="showCouponUsage = true;" src="https://o.666visa.cn/static/ssqpeer/order/icon-query.png">
        </div>
        <div class="exchange-coupon" @click="showExchangeCoupon = true;">
          <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/address-add.png">
          <span>兑换优惠券</span>
        </div>
      </div>
      <div class="order-coupons-center" v-if="orderCoupons && orderCoupons.length" :class="{ 'fold': fold }" :style="orderCouponsCenterStyle">
        <coupon class="order-comfirm-coupon" :selected="coupon.id === orderSelectedCoupon.id"
          v-for="(coupon, index) in orderCoupons" :key="index" :coupon="coupon" :selectable="true"
          :couponIndex="index" @couponExport="couponExport"></coupon>
      </div>

      <div class="expand-box"  v-if="orderCoupons && orderCoupons.length > 2">
        <div class="expand-content" @click="fold = !fold;">
          <div class="expand-text" v-if="!fold">收起</div>
          <div class="expand-text" v-else>更多{{orderCoupons.length - 2}}张优惠券</div>
          <img class="down-icon" :class="{expand: !fold }" src="https://o.666visa.cn/static/ssqpeer/order/icon-down-blue.png" alt="">
        </div>
      </div>

      <!-- 兑换优惠券 -->
      <exchange-coupon v-model="showExchangeCoupon" :order-id="orderId" @addedCoupon="addedCoupon"></exchange-coupon>

      <!-- 指定商品优惠券说明 -->
      <coupon-explain :coupon="orderCoupons[couponIndex]" v-model="showCouponExplain" v-on:couponExplainClose="couponExplainClose()"></coupon-explain>

    </div>
    <div v-else class="special-price-coupon">
      <el-checkbox class="check-coupon" :disabled="!!orderSpecialPrice"></el-checkbox>
      <span class="coupon-title">使用优惠券</span>
      <img class="query-icon" @click="showCouponUsage = true;" src="https://o.666visa.cn/static/ssqpeer/order/icon-query.png">
      <span class="explain">仅限非特价商品使用</span>
    </div>

    <!-- 优惠券使用说明 -->
    <coupon-usage v-model="showCouponUsage"></coupon-usage>
  </div>
</template>

<script>
import coupon from '../../../components/coupon/order-coupon-item';
import couponUsage from '../../user/user-children/components/coupon-usage';
import exchangeCoupon from '../modals/exchange-coupon';
import couponExplain from '../../../components/coupon/coupon-explain';
import sCheckbox from '../../../components/form/s-checkbox';

export default {
  name: 'order-coupons',
  components: {
    coupon,
    couponUsage,
    exchangeCoupon,
    couponExplain,
    sCheckbox,
  },
  props: {
    orderUseCoupon: {
      type: Boolean,
      required: true,
      default: false,
    },
    orderCoupons: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    orderSelectedCoupon: {
      type: Object,
      default: () => ({}),
    },
    couponReducePrice: {
      type: Number,
      default: 0,
    },
    orderId: {
      type: Number,
      required: true,
    },
    orderVisaPrice: {
      type: Number,
      required: true,
    },
    orderSpecialPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      useCoupon: this.orderUseCoupon,
      fold: true,
      showCouponUsage: false,
      showExchangeCoupon: false,
      couponIndex: 0,
      showCouponExplain: false,
    };
  },
  computed: {

    // 优惠券列表样式
    orderCouponsCenterStyle() {
      return {
        'max-height': `${Math.ceil(this.orderCoupons.length / 2) * 108}px`,
      };
    },
  },
  methods: {

    // 修改是否使用优惠券
    changeUseCouponSelect(check) {
      this.$emit('changeUseCoupon', check);
      if (check) {
        // 默认打开如果没有选中任何一个选中第一个
        if (!this.orderSelectedCoupon.id) {
          this.$emit('changeSelectedCoupon', this.orderCoupons[0]);
        }
      } else {
        // 默认打开是选中第一个
        this.$emit('changeSelectedCoupon', {});
      }
    },

    // 选择优惠券
    selectedCoupon(coupon) {
      if (!this.selectedCoupon.id) {
        this.$emit('changeUseCoupon', true);
      }
      this.$emit('changeSelectedCoupon', coupon);
    },

    // 添加优惠券
    addedCoupon() {
      this.$emit('addedCoupon');
    },

    // 指定商品弹窗关闭时
    couponExplainClose() {
      this.showCouponExplain = false;
    },

    // 打开指定商品弹窗时
    couponInfo(value) {
      this.showCouponExplain = value.isShowCouponExplain;
      this.couponIndex = value.couponIndex;
    },

    couponExport(type, value) {
      if (type === 'selectCoupon') {
        this.selectedCoupon(value);
      } else if (type === 'couponExplain') {
        this.couponInfo(value);
      }
    },
  },
  watch: {
    orderUseCoupon(newVal) {
      this.useCoupon = newVal;
    },
  },
};
</script>

<style lang="less">
@import  '../../../assets/less/variable';
#order-coupons {
  background-color: white;
  margin-top: 20px;
  line-height: 1;

  .order-coupons-body{
    padding-bottom: 16px;
  }

  .order-coupons-header {
    height: 60px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left-content {
      display: flex;
      align-items: center;
      .check-coupon {
        margin-right: 12px;
      }
      .coupon-title {
        font-size: 20px;
        color: #2F333D;
        font-weight: 600;
      }
      .price {
        font-size: 14px;
        line-height: 1;
        color: #5F666E;
        span {
          color: #FF6464;
        }
      }
      .query-icon {
        cursor: pointer;
        width: 18px;
      }
      .coupon-title + .query-icon{
        margin-left: 8px;
      }
    }
    .exchange-coupon {
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      .icon {
        width: 15px;
        height: 19px;
      }
      span {
        margin-top: 1px;
        font-size: 14px;
        line-height: 1;
        color: #599FFF;
        margin-left: 2px;
      }
    }
  }
  .order-coupons-center {
    display: flex;
    flex-wrap: wrap;
    padding-left: 24px;
    margin-top: 10px;
    overflow: hidden;
    transition: max-height .2s ease-in;
    &::after {
      content: '';
      width: 260px;
    }
    &.fold {
      max-height: 108px !important;
    }
    .order-comfirm-coupon {
      margin-bottom: 16px;
      margin-right: 20px;
    }
  }
  .expand-box{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #599FFF;
    font-size: 14px;
    position: relative;
    .expand-content{
      position: relative;
      z-index: 2;
      padding: 0 16px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .down-icon{
        width: 14px;
        height: 14px;
        margin-left: 6px;
        transition: 0.15s all;
        &.expand{
          transform: rotate(180deg);
        }
      }
    }

  }
}
.special-price-coupon {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 24px;
  .check-coupon {
    margin-right: 12px;
    font-size: 0;
  }
  .coupon-title{
    font-size: 20px;
    color: #2F333D;
    font-weight: 600;
    margin-right: 6px;
  }
  .query-icon {
    cursor: pointer;
    width: 18px;
    margin-right: 6px;
  }
  .explain {
    font-size: 14px;
    color: #91999F;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-coupons.vue